export default __webpack_public_path__ + "static/media/titleUpload.eb8a4d4b.svg";